import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ico-paginator-arrow",
  "use": "ico-paginator-arrow-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"ico-paginator-arrow\">\n    <path d=\"M6.48438 13.8594L11.9844 8.35938L12.3281 8L11.9844 7.64062L6.48438 2.14062L5.76563 2.85938L10.9061 7.99988L5.76562 13.1404L6.48438 13.8594Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol